import { render, staticRenderFns } from "./TakeAiInterview.vue?vue&type=template&id=28ea70ea"
import script from "./TakeAiInterview.vue?vue&type=script&lang=js"
export * from "./TakeAiInterview.vue?vue&type=script&lang=js"
import style0 from "./TakeAiInterview.vue?vue&type=style&index=0&id=28ea70ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports